// extracted by mini-css-extract-plugin
export default {"loadingStyle":"Loading_loadingStyle__-7XKD","spin":"Loading_spin__grgdF"};